"use client";

import dynamic from "next/dynamic";

// Centralized lazy (code-split) versions of the heavy, below-the-fold widgets.
// ActivityCharts/HrFixPanel pull in recharts (~0.5MB); SportChanger/DeviceChanger
// pull in @garmin/fitsdk (via lib/fit-options). They only render after a file is
// loaded, so deferring them keeps those libraries out of the initial bundle that
// gates first paint on the converter, batch, and repair pages.
//
// Declaring the deferral here (rather than at each call site) means every
// consumer imports the code-split version by construction — a new consumer can't
// accidentally reach for the eager static import and quietly undo the win.

const ChartSkeleton = () => (
  <div className="h-72 rounded-xl glass-panel animate-pulse" />
);

export const ActivityCharts = dynamic(
  () => import("@/components/activity-charts").then((m) => m.ActivityCharts),
  { ssr: false, loading: ChartSkeleton }
);

export const HrFixPanel = dynamic(
  () => import("@/components/hr-fix-panel").then((m) => m.HrFixPanel),
  { ssr: false }
);

export const SportChanger = dynamic(
  () => import("@/components/sport-changer").then((m) => m.SportChanger),
  { ssr: false }
);

export const DeviceChanger = dynamic(
  () => import("@/components/device-changer").then((m) => m.DeviceChanger),
  { ssr: false }
);
